import { load } from '@progress/kendo-vue-intl';

type CldrJsonModule = () => Promise<{ default: unknown }>;

const supplementalModules: CldrJsonModule[] = [
  () => import('cldr-core/supplemental/likelySubtags.json'),
  () => import('cldr-core/supplemental/currencyData.json'),
  () => import('cldr-core/supplemental/weekData.json'),
];

const localeCldrModules = {
  en: [
    () => import('cldr-numbers-full/main/en/numbers.json'),
    () => import('cldr-numbers-full/main/en/currencies.json'),
    () => import('cldr-dates-full/main/en/ca-gregorian.json'),
    () => import('cldr-dates-full/main/en/dateFields.json'),
  ],
  'en-GB': [
    () => import('cldr-numbers-full/main/en-GB/numbers.json'),
    () => import('cldr-numbers-full/main/en-GB/currencies.json'),
    () => import('cldr-dates-full/main/en-GB/ca-gregorian.json'),
    () => import('cldr-dates-full/main/en-GB/dateFields.json'),
  ],
  bg: [
    () => import('cldr-numbers-full/main/bg/numbers.json'),
    () => import('cldr-numbers-full/main/bg/currencies.json'),
    () => import('cldr-dates-full/main/bg/ca-gregorian.json'),
    () => import('cldr-dates-full/main/bg/dateFields.json'),
  ],
  cs: [
    () => import('cldr-numbers-full/main/cs/numbers.json'),
    () => import('cldr-numbers-full/main/cs/currencies.json'),
    () => import('cldr-dates-full/main/cs/ca-gregorian.json'),
    () => import('cldr-dates-full/main/cs/dateFields.json'),
  ],
  da: [
    () => import('cldr-numbers-full/main/da/numbers.json'),
    () => import('cldr-numbers-full/main/da/currencies.json'),
    () => import('cldr-dates-full/main/da/ca-gregorian.json'),
    () => import('cldr-dates-full/main/da/dateFields.json'),
  ],
  de: [
    () => import('cldr-numbers-full/main/de/numbers.json'),
    () => import('cldr-numbers-full/main/de/currencies.json'),
    () => import('cldr-dates-full/main/de/ca-gregorian.json'),
    () => import('cldr-dates-full/main/de/dateFields.json'),
  ],
  el: [
    () => import('cldr-numbers-full/main/el/numbers.json'),
    () => import('cldr-numbers-full/main/el/currencies.json'),
    () => import('cldr-dates-full/main/el/ca-gregorian.json'),
    () => import('cldr-dates-full/main/el/dateFields.json'),
  ],
  es: [
    () => import('cldr-numbers-full/main/es/numbers.json'),
    () => import('cldr-numbers-full/main/es/currencies.json'),
    () => import('cldr-dates-full/main/es/ca-gregorian.json'),
    () => import('cldr-dates-full/main/es/dateFields.json'),
  ],
  et: [
    () => import('cldr-numbers-full/main/et/numbers.json'),
    () => import('cldr-numbers-full/main/et/currencies.json'),
    () => import('cldr-dates-full/main/et/ca-gregorian.json'),
    () => import('cldr-dates-full/main/et/dateFields.json'),
  ],
  fi: [
    () => import('cldr-numbers-full/main/fi/numbers.json'),
    () => import('cldr-numbers-full/main/fi/currencies.json'),
    () => import('cldr-dates-full/main/fi/ca-gregorian.json'),
    () => import('cldr-dates-full/main/fi/dateFields.json'),
  ],
  fr: [
    () => import('cldr-numbers-full/main/fr/numbers.json'),
    () => import('cldr-numbers-full/main/fr/currencies.json'),
    () => import('cldr-dates-full/main/fr/ca-gregorian.json'),
    () => import('cldr-dates-full/main/fr/dateFields.json'),
  ],
  ga: [
    () => import('cldr-numbers-full/main/ga/numbers.json'),
    () => import('cldr-numbers-full/main/ga/currencies.json'),
    () => import('cldr-dates-full/main/ga/ca-gregorian.json'),
    () => import('cldr-dates-full/main/ga/dateFields.json'),
  ],
  he: [
    () => import('cldr-numbers-full/main/he/numbers.json'),
    () => import('cldr-numbers-full/main/he/currencies.json'),
    () => import('cldr-dates-full/main/he/ca-gregorian.json'),
    () => import('cldr-dates-full/main/he/dateFields.json'),
  ],
  hr: [
    () => import('cldr-numbers-full/main/hr/numbers.json'),
    () => import('cldr-numbers-full/main/hr/currencies.json'),
    () => import('cldr-dates-full/main/hr/ca-gregorian.json'),
    () => import('cldr-dates-full/main/hr/dateFields.json'),
  ],
  hu: [
    () => import('cldr-numbers-full/main/hu/numbers.json'),
    () => import('cldr-numbers-full/main/hu/currencies.json'),
    () => import('cldr-dates-full/main/hu/ca-gregorian.json'),
    () => import('cldr-dates-full/main/hu/dateFields.json'),
  ],
  it: [
    () => import('cldr-numbers-full/main/it/numbers.json'),
    () => import('cldr-numbers-full/main/it/currencies.json'),
    () => import('cldr-dates-full/main/it/ca-gregorian.json'),
    () => import('cldr-dates-full/main/it/dateFields.json'),
  ],
  ja: [
    () => import('cldr-numbers-full/main/ja/numbers.json'),
    () => import('cldr-numbers-full/main/ja/currencies.json'),
    () => import('cldr-dates-full/main/ja/ca-gregorian.json'),
    () => import('cldr-dates-full/main/ja/dateFields.json'),
  ],
  lb: [
    () => import('cldr-numbers-full/main/lb/numbers.json'),
    () => import('cldr-numbers-full/main/lb/currencies.json'),
    () => import('cldr-dates-full/main/lb/ca-gregorian.json'),
    () => import('cldr-dates-full/main/lb/dateFields.json'),
  ],
  lt: [
    () => import('cldr-numbers-full/main/lt/numbers.json'),
    () => import('cldr-numbers-full/main/lt/currencies.json'),
    () => import('cldr-dates-full/main/lt/ca-gregorian.json'),
    () => import('cldr-dates-full/main/lt/dateFields.json'),
  ],
  lv: [
    () => import('cldr-numbers-full/main/lv/numbers.json'),
    () => import('cldr-numbers-full/main/lv/currencies.json'),
    () => import('cldr-dates-full/main/lv/ca-gregorian.json'),
    () => import('cldr-dates-full/main/lv/dateFields.json'),
  ],
  mt: [
    () => import('cldr-numbers-full/main/mt/numbers.json'),
    () => import('cldr-numbers-full/main/mt/currencies.json'),
    () => import('cldr-dates-full/main/mt/ca-gregorian.json'),
    () => import('cldr-dates-full/main/mt/dateFields.json'),
  ],
  nl: [
    () => import('cldr-numbers-full/main/nl/numbers.json'),
    () => import('cldr-numbers-full/main/nl/currencies.json'),
    () => import('cldr-dates-full/main/nl/ca-gregorian.json'),
    () => import('cldr-dates-full/main/nl/dateFields.json'),
  ],
  pl: [
    () => import('cldr-numbers-full/main/pl/numbers.json'),
    () => import('cldr-numbers-full/main/pl/currencies.json'),
    () => import('cldr-dates-full/main/pl/ca-gregorian.json'),
    () => import('cldr-dates-full/main/pl/dateFields.json'),
  ],
  pt: [
    () => import('cldr-numbers-full/main/pt/numbers.json'),
    () => import('cldr-numbers-full/main/pt/currencies.json'),
    () => import('cldr-dates-full/main/pt/ca-gregorian.json'),
    () => import('cldr-dates-full/main/pt/dateFields.json'),
  ],
  ro: [
    () => import('cldr-numbers-full/main/ro/numbers.json'),
    () => import('cldr-numbers-full/main/ro/currencies.json'),
    () => import('cldr-dates-full/main/ro/ca-gregorian.json'),
    () => import('cldr-dates-full/main/ro/dateFields.json'),
  ],
  sk: [
    () => import('cldr-numbers-full/main/sk/numbers.json'),
    () => import('cldr-numbers-full/main/sk/currencies.json'),
    () => import('cldr-dates-full/main/sk/ca-gregorian.json'),
    () => import('cldr-dates-full/main/sk/dateFields.json'),
  ],
  sl: [
    () => import('cldr-numbers-full/main/sl/numbers.json'),
    () => import('cldr-numbers-full/main/sl/currencies.json'),
    () => import('cldr-dates-full/main/sl/ca-gregorian.json'),
    () => import('cldr-dates-full/main/sl/dateFields.json'),
  ],
  sr: [
    () => import('cldr-numbers-full/main/sr/numbers.json'),
    () => import('cldr-numbers-full/main/sr/currencies.json'),
    () => import('cldr-dates-full/main/sr/ca-gregorian.json'),
    () => import('cldr-dates-full/main/sr/dateFields.json'),
  ],
  sv: [
    () => import('cldr-numbers-full/main/sv/numbers.json'),
    () => import('cldr-numbers-full/main/sv/currencies.json'),
    () => import('cldr-dates-full/main/sv/ca-gregorian.json'),
    () => import('cldr-dates-full/main/sv/dateFields.json'),
  ],
  tr: [
    () => import('cldr-numbers-full/main/tr/numbers.json'),
    () => import('cldr-numbers-full/main/tr/currencies.json'),
    () => import('cldr-dates-full/main/tr/ca-gregorian.json'),
    () => import('cldr-dates-full/main/tr/dateFields.json'),
  ],
};

const DEFAULT_CLDR_LOCALE: keyof typeof localeCldrModules = 'en';

const resolveCldrLocale = (locale: string) => {
  if (locale in localeCldrModules) {
    return locale;
  }

  const [language = ''] = locale.split('-');

  return language in localeCldrModules ? language : DEFAULT_CLDR_LOCALE;
};

const loadModules = async (modules: CldrJsonModule[]) => {
  const loaded = await Promise.all(modules.map((module) => module()));

  return loaded.map((module) => module.default);
};

export const loadCldrData = async (locale: string) => {
  const resolvedLocale = resolveCldrLocale(locale);
  const modules = [
    ...supplementalModules,
    ...localeCldrModules[resolvedLocale],
  ];
  const data = await loadModules(modules);

  load(...data);
};

export const loadAllCldrData = async () => {
  const modules = [
    ...supplementalModules,
    ...Object.values(localeCldrModules).flat(),
  ];
  const data = await loadModules(modules);

  load(...data);
};
